import * as technicians from './list'

import { Technician } from 'app/types/users/technician'

export const allTechnicians: Technician[] = Object.values(technicians).sort(
    (previous, current) =>
        previous.last_name.localeCompare(current.last_name) ||
        previous.first_name.localeCompare(current.first_name),
)
